import { render, staticRenderFns } from "./PrizeBlock.vue?vue&type=template&id=82b8f4ac&scoped=true&"
import script from "./PrizeBlock.vue?vue&type=script&lang=js&"
export * from "./PrizeBlock.vue?vue&type=script&lang=js&"
import style0 from "./PrizeBlock.vue?vue&type=style&index=0&id=82b8f4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b8f4ac",
  null
  
)

export default component.exports